export default "__VITE_ASSET__DBhnaNLt__"